module.exports = __webpack_public_path__ + "img/新增用户icon@2x.365b3e2d.png";